import { Link } from 'react-router-dom';

/**
 * Renders a staff member's name as a link to their unified profile page
 * (/staff/:id). The profile page itself enforces role-based visibility:
 * director sees all, lead admin sees self + direct reports, staff sees self.
 *
 * Usage:
 *   <StaffLink id={c.id} name={`${c.first_name} ${c.last_name}`} />
 *   <StaffLink id={row.staff_user_id}>{row.staff_name}</StaffLink>
 */
export default function StaffLink({ id, name, children, className = '' }) {
  if (!id) return <span className={className}>{children || name || '—'}</span>;
  return (
    <Link
      to={`/staff/${id}`}
      onClick={(e) => e.stopPropagation()}
      className={`hover:text-orange-500 hover:underline transition-colors ${className}`}
    >
      {children || name || '—'}
    </Link>
  );
}
